// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"371":"e995db9d","477":"a6440883","676":"bc3bfb0f","770":"bd2a809d","791":"3c4ed7dd"}[chunkId] + ".chunk.css";
};